// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__WEgyj"};